import { create } from 'zustand';

interface FreemiumCheckoutState {
  clientSecret: string | null;
  setClientSecret: (clientSecret: string | null) => void;
}

export const useFreemiumCheckoutStore = create<FreemiumCheckoutState>()(set => ({
  clientSecret: null,
  setClientSecret: clientSecret => set({ clientSecret }),
}));
